/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ name: NonNullable<unknown> }} Voice_Manager_Unpin_LabelInputs */

const en_voice_manager_unpin_label = /** @type {(inputs: Voice_Manager_Unpin_LabelInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Unpin ${i?.name}`)
};

const fr_voice_manager_unpin_label = /** @type {(inputs: Voice_Manager_Unpin_LabelInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Depingler ${i?.name}`)
};

const de_voice_manager_unpin_label = /** @type {(inputs: Voice_Manager_Unpin_LabelInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.name} entriegeln`)
};

const it_voice_manager_unpin_label = /** @type {(inputs: Voice_Manager_Unpin_LabelInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Sblocca ${i?.name}`)
};

const ru_voice_manager_unpin_label = /** @type {(inputs: Voice_Manager_Unpin_LabelInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Открепить ${i?.name}`)
};

const es_voice_manager_unpin_label = /** @type {(inputs: Voice_Manager_Unpin_LabelInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Desanclar ${i?.name}`)
};

const zh_cn2_voice_manager_unpin_label = /** @type {(inputs: Voice_Manager_Unpin_LabelInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`取消固定${i?.name}`)
};

const ja_voice_manager_unpin_label = /** @type {(inputs: Voice_Manager_Unpin_LabelInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.name} のピンを外す`)
};

const hi_voice_manager_unpin_label = /** @type {(inputs: Voice_Manager_Unpin_LabelInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.name} को अनपिन करें`)
};

const pt_pt2_voice_manager_unpin_label = /** @type {(inputs: Voice_Manager_Unpin_LabelInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Desafixar ${i?.name}`)
};

/**
* | output |
* | --- |
* | "Unpin {name}" |
*
* @param {Voice_Manager_Unpin_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const voice_manager_unpin_label = /** @type {((inputs: Voice_Manager_Unpin_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Voice_Manager_Unpin_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_voice_manager_unpin_label(inputs)
	if (locale === "de") return de_voice_manager_unpin_label(inputs)
	if (locale === "it") return it_voice_manager_unpin_label(inputs)
	if (locale === "ru") return ru_voice_manager_unpin_label(inputs)
	if (locale === "es") return es_voice_manager_unpin_label(inputs)
	if (locale === "zh-CN") return zh_cn2_voice_manager_unpin_label(inputs)
	if (locale === "ja") return ja_voice_manager_unpin_label(inputs)
	if (locale === "hi") return hi_voice_manager_unpin_label(inputs)
	if (locale === "pt-PT") return pt_pt2_voice_manager_unpin_label(inputs)
	return en_voice_manager_unpin_label(inputs)
});